import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatMobileNumber',
    standalone: false
})

export class FormatMobileNumberPipe implements PipeTransform {

  transform(value: any): any {
    if(value.includes('-')) {
      const newArray = value.toString().split('-');
      return newArray[1];
    } else {
      return value;
    }
  }

}